import { StringSchema, string } from 'yup';
import moment from 'moment';
import { dateIsValid } from '@/utils';

export default function (this: StringSchema, message: string) {
  return this.test('cnhFirstLicense', message, function (value) {
    const [, nestedParent] = this.from;
    const { birthday } = nestedParent.value;
    const { expirationDate } = this.parent;
    const isBirthdayDateInvalid = !dateIsValid(birthday);
    const isExpirationDateInvalid = !dateIsValid(expirationDate);

    if (isBirthdayDateInvalid) return this.createError({ message: 'Preencha a data de nascimento' });

    if (isExpirationDateInvalid) return this.createError({ message: 'Preencha a validade da CNH' });

    const dateFormat = 'DD/MM/YYYY';
    const allowMinorAgeYear = 1984;
    const licenseYear = moment(value, dateFormat).year();
    const hasMinorAge = licenseYear <= allowMinorAgeYear;
    const minorAge = hasMinorAge ? 17 : 18;

    const birthdayPlusMinorAge = moment(birthday, dateFormat).add(minorAge, 'y').subtract(1, 'd').format(dateFormat);
    const expirationDatePlusOneDayMinusOneYear = moment(expirationDate, dateFormat)
      .add(1, 'd')
      .subtract(1, 'y')
      .format(dateFormat);

    if (!string().minDate(birthdayPlusMinorAge).isValidSync(value))
      return this.createError({ message: `A data deve ser posterior a ${birthdayPlusMinorAge}` });
    if (!string().maxDate(expirationDatePlusOneDayMinusOneYear).isValidSync(value))
      return this.createError({ message: `A data deve ser no máximo ${expirationDatePlusOneDayMinusOneYear}` });

    return true;
  });
}
